import { getClaimedAmount as getClaimedAmountFn, } from "@bracket/contractor-next/bracket-escrow";
import type { EthereumAddress, WEIString, } from "@bracket/types";
import { effectZeroBigInt, } from "@utils";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getStoredClaim, } from "./getStoredClaim";



export const getClaimedAmount = async ( wallet: EthereumAddress, ): Promise<{ amount: WEIString; claimable: boolean; proof: string[]; }> => {

	const claim = await getStoredClaim(wallet);
	if(!claim || claim.claimed) {
		return { amount: "0", claimable: false, proof: [] };
	}

	const { amount, proof, } = claim;
	const available = effectZeroBigInt(BigInt(amount), 18);
	if(available > BigInt(0)) {
		const claimedAmount = await getClaimedAmountFn({ address: wallet, config, });
		if(effectZeroBigInt(available - claimedAmount, 18) > BigInt(0)) {
			return { amount, claimable: true, proof, };
		}
	}

	return { amount, claimable: false, proof: [], };
};
